// src/components/VesselSelector.jsx
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../theme/orb-theme.css";
import { Panel, Button, Card, Stack } from "../theme/OrbUI";

export default function VesselSelector() {
  const [vessels, setVessels] = useState([]);
  const [selected, setSelected] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    let isMounted = true;
    fetch("/api/vessels/")
      .then((res) => res.json())
      .then((data) => {
        if (isMounted) {
          const vesselList = Array.isArray(data) ? data : data.results || [];
          setVessels(vesselList);
        }
      })
      .catch((err) => {
        if (isMounted) console.error("Fetch failed:", err);
      });
    return () => {
      isMounted = false;
    };
  }, []);

  const handleSelect = () => {
    if (!selected) {
      alert("Please select a vessel");
      return;
    }

    
    fetch("/api/current-vessel/", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ vessel_id: selected }),
    })
      .then((res) => res.json())
      .then(() => {
        localStorage.setItem("selectedVesselId", selected);
        sessionStorage.setItem("selectedVesselId", selected);
        navigate("/login");
      })
      .catch((err) => {
        console.warn("Save failed, continuing locally:", err);
        localStorage.setItem("selectedVesselId", selected);
        sessionStorage.setItem("selectedVesselId", selected);
        navigate("/login");
      });
  };

  return (
   
  <div className="orb-theme">
    <div className="vessel-form-wrapper">
      <Panel title="Vessel Selection">
        <Stack>
          <div>
            <h2>Select Vessel</h2>
            <p className="help">Choose your vessel to continue</p>
          </div>

          <div className="field">
            <select
              value={selected}
              onChange={(e) => setSelected(e.target.value)}
              required
            >
              <option value="">Choose Vessel</option>
              {vessels.map((v) => (
                <option key={v.id} value={v.id}>
                  {v.vesselCode} | {v.vesselName}
                </option>
              ))}
            </select>
          </div>

          <div className="actions" style={{ justifyContent: "flex-end" }}>
            <Button glow type="button" onClick={handleSelect}>
              Submit
            </Button>
          </div>
        </Stack>
      </Panel>
    </div>
  </div>
);
  
}
